import { CSSProperties } from 'react'

import { createStyles } from 'utils/css'

import { BoxStyles } from './SideDrawer.types'
import { ISideDrawer } from './SideDrawer.types'

export const root = ({
  background,
  styles
}: Pick<ISideDrawer, 'background' | 'styles'>) =>
  createStyles(({ colors, radii }) => {
    const defaultStyles: CSSProperties = {
      background: colors[background],
      position: 'fixed',
      right: 0,
      bottom: 0,
      top: 0,
      zIndex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
      borderRadius: `${radii.xxl} 0 0 ${radii.xxl}`
    }
    return { ...defaultStyles, ...styles?.root }
  })

export const content = ({ styles }: Pick<ISideDrawer, 'styles'>) =>
  createStyles(() => {
    const defaultStyles: CSSProperties = {
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }
    return { ...defaultStyles, ...styles?.content }
  })

export const btnWrap = () =>
  createStyles(({ spacing }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: spacing(0.5),
    '@media print': {
      display: 'none'
    }
  }))

export const btn = ({ close, styles }: Pick<ISideDrawer, 'close' | 'styles'>) =>
  createStyles(({ colors, size }) => {
    const defaultStyles: CSSProperties = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '100%',
      width: '3rem !important' /* 48px */,
      height: size(4.8),
      background: !close ? colors.grey5 : colors[close.background],
      color: !close ? colors.purple30 : colors[close.color],
      textAlign: 'center'
    }
    return { ...defaultStyles, ...styles?.btn }
  })

/**
 * helper styles place CTAs at bottom,
 * not used in component but can be
 * imported and used for this use case
 */
export const wrapper = () =>
  createStyles(({ justifications }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: justifications.between,
    height: '100%'
  }))

export const bottom = () =>
  createStyles(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 16
  }))

export const close: BoxStyles = {
  outer: {
    display: 'flex',
    justifyContent: 'flex-end',
    // @ts-ignore
    '@media print': { display: 'none' }
  },
  inner: {
    flex: 1
  }
}

export const overlay = (isOpen: boolean) =>
  createStyles(({ effects }) => ({
    ...effects.overlay,
    zIndex: isOpen && 100,
    position: isOpen && 'fixed',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  }))
